// ダッシュボード
import React, { useState, useEffect, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import axios from '../axios';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../molecules/LoadingModal';
import { Row } from 'react-bootstrap';
import { Parents, Childs, Contents } from '../types/DashboardIndex';
import DashboardIndexChild from '../organisms/DashboardIndexChild';

// 案件一覧のURL
const reception_list_base_url = `${location.origin}${process.env.MIX_MOCK_URL}/staff/list`;

const DashboardIndex: React.FC = () => {
  const [is_loading, setIsLoading] = useState(false);
  const [error_message, setErrorMessage] = useState();
  const [header_message, setHeaderMessage] = useState('');
  const [news, setNews] = useState([]);
  const [parents, setParents] = useState<Array<Parents>>([]);
  const [childs, setChilds] = useState<Array<Childs>>([]);
  const [contents, setContents] = useState<Array<Contents>>([]);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowzerBack();
    const getReception = async () => {
      try {
        //ローディング画面表示
        setIsLoading(true);
        const response = await axios.get('staff/dashboard/list_count');
        console.log(response.data);
        setParents(response.data.parents);
        setChilds(response.data.childs);
        setContents(response.data.contents);
        setNews(response.data.news);
        setHeaderMessage(response.data.header_message);
      } catch (error) {
        console.error(error.message);
        setErrorMessage(error.response.data.message);
      } finally {
        //ローディング画面非表示
        setIsLoading(false);
      }
    };

    // 案件情報を取得
    getReception();
  }, []);

  //親項目を表示
  const makeParents = () => {
    return parents.map((parent) => {
      return (
        <div className="col-md-6" key={parent.parent_id}>
          <div className="h2">{parent.item_name}</div>
          <DashboardIndexChild childs={childs} parent_id={parent.parent_id} contents={contents} />
        </div>
      );
    });
  };

  // 案件一覧へ戻るボタンのクリックイベントハンドラ
  const handleClick = () => {
    location.replace(reception_list_base_url);
  };

  return (
    <React.Fragment key={'reception_01'}>
      <div className="title_block">{header_message}</div>
      <div className="container">
        {typeof error_message === 'undefined' ? (
          // 取得OK
          // 案件ステータス情報
          <React.Fragment key={'reception_02'}>
            <div className="row" key={'reception_03'}>
              {contents.length > 0 && makeParents()}
            </div>
            <div className="py-3">
              <fieldset className="dashbord_border notice_hw mx-2 my-3">
                <legend className="w-auto px-3 ms-3">お知らせ</legend>
                <div className="notice px-3 ms-3">
                  {news.map((line: string, index: number) => (
                    <div key={index}>{line}</div>
                  ))}
                </div>
              </fieldset>
            </div>
          </React.Fragment>
        ) : (
          // 取得NG
          <div className="alert alert-dange" role="alert">
            {error_message}
          </div>
        )}
        {/* 案件一覧へ戻るボタン */}
        <Row className="ml-2">
          <a className="btn-main-color btn btn-xl" onClick={handleClick}>
            案件一覧へ戻る
          </a>
        </Row>
        {/* ローディング画面 */}
        <LoadingModal show={is_loading} />
      </div>
    </React.Fragment>
  );
};

const container = document.getElementById('dashboard-index');
if (container) {
  const root = createRoot(container);
  root.render(<DashboardIndex />);
}
